import { render, staticRenderFns } from "./inventoryStockGlassServiceSummaryWidget.vue?vue&type=template&id=e963ba92&"
import script from "./inventoryStockGlassServiceSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryStockGlassServiceSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports